import { NAME } from './constants';

export const ADD_DOCUMENT_ID = `${NAME}/ADD_DOCUMENT_ID`;
export const REMOVE_DOCUMENT_ID = `${NAME}/REMOVE_DOCUMENT_ID`;
export const SET_FILES = `${NAME}/SET_FILES`;
export const RESET_DOCUMENTS = `${NAME}/RESET_DOCUMENTS`;
export const SET_UPLOAD_ERRORS = `${NAME}/SET_UPLOAD_ERRORS`;
